import React, { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

export interface ICardCarouselProps {
  children: React.ReactNode[];
  bgColor?: string;
}

const RecentOrderCardCarousel: FC<ICardCarouselProps> = ({ children, bgColor }) => {
  return <ResponsiveCarousel bgColor={bgColor}>{children}</ResponsiveCarousel>;
};

export default RecentOrderCardCarousel;
